import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from './pages/Home/Home';
import ProductsPage from './pages/Products/ProductsPage';


function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/:slug" element={<ProductsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;